<div class="grid__cell grid__cell--widget grid__cell--full widget__bag" [dragula]='"widget-bag"'>
  <div class="widget__wrap">
    <div class="widget" id="pages-widget">
      <h2 class="widget__header">
        <span class="widget__header__title">
          <i class="widget__header__icon ico-angle-down"></i> Vyplněný formulář</span>
      </h2>
      <div class="widget__content formrecords">
        <ng-container *ngIf="isInitialized && records && records.length > 0">
          <div class="formrecord" *ngFor="let record of records | paginate: { id: 'formrecords', itemsPerPage: pagination.pageSize, currentPage:
            p, totalItems: pagination.total }">
            <div class="formrecord__created">{{ record.created | date:'d. M. yyyy HH:mm' }}</div>
            <a [routerLink]="{ outlets: { 'modal': ['formrecord-delete', record.id] } }"
              [queryParams]="{header:'Opravdu chcete smazat tento záznam?', body: 'Položku již nebude možné obnovit.'}"
              class="widget__list__actions__link widget__list__actions__link--remove formrecord__delete">
              <i class="ico-remove"></i>
            </a>
            <ng-container *ngFor="let item of generateArray(record.content)">
              <strong class="formrecord__name">{{ item.key }}:</strong> &nbsp;
              <span class="formrecord__entry">{{ item.value }}</span><br>
            </ng-container>
            <br>
          </div>
        </ng-container>
        <pagination-controls *ngIf="pagination.pageSize > 0 && isInitialized" id="formrecords" (pageChange)="pageChanged($event)"
          maxSize="9" directionLinks="true" autoHide="true" previousLabel="" nextLabel="" screenReaderPaginationLabel="Pagination"
          screenReaderPageLabel="Stránka" screenReaderCurrentLabel="Jste na stránce">
        </pagination-controls>

        <div *ngIf="!isInitialized" class="widget__content loading"></div>

        <swb-no-data *ngIf="records && records.length === 0 && isInitialized"></swb-no-data>
      </div>
    </div>
  </div>
</div>


<router-outlet name="modal"></router-outlet>